import { get, post } from './common'

type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>
type ApiBasePageResult<T> = ApiTypes.ApiBasePageResult<T>

export namespace user {
  export function login(data: PostData.LoginModel) {
    return post<ApiBaseResult<ServerData.LoginData>>('/login', {}, { ...data })
  }

  // 获取用户信息
  export function getUserInfo() {
    return get<ApiBaseResult<ServerData.UserInfo>>('/user_info', {})
  }

  // 获取团队用户列表
  export function getTeamInUserList(data: PostData.Team.UserListModel) {
    return get<ApiBasePageResult<ServerData.Team.UserListData>>('/workspace/user_search', {
      ...data,
    })
  }

  // 删除用户
  export function delTeamInUser(data: PostData.Team.DelUserModel) {
    return post<ApiBaseResult<null>>('/workspace/delete_user', {}, { ...data })
  }

  // 添加用户到团队
  export function addTeamInUser(data: PostData.Team.AddUserModel) {
    return post<ApiBaseResult<{ pwd: string }>>('/workspace/add_user', {}, { ...data })
  }

  // 修改用户在团队里权限
  export function updTeamInUserPermission(data: PostData.Team.UpdUserPermissionModel) {
    return post<ApiBaseResult<null>>('/workspace/update_permission', {}, { ...data })
  }

  // 重置用户密码
  export function resetTeamInUserPassword(workspaceId: string, userId: number) {
    return post<ApiBaseResult<{ pwd: string }>>(
      '/workspace/update_user_pwd',
      {},
      { workspaceId, userId }
    )
  }

  // 获取枚举数据
  export function getEnumData() {
    return get<ApiBaseResult<ServerData.EnumData>>('/enum_info', {})
  }
}
